import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { APP_CONFIG } from '../app.config.ts';

const { host } = window.location;
const hostArr = host.split('.').reverse();
const domain = `${hostArr[1]}.${hostArr[0]}`;

i18n
  .use(initReactI18next)
  .use(Backend)
  .use(I18nextBrowserLanguageDetector)
  .init({
    detection: {
      order: ['cookie'],
      caches: ['cookie'],
      cookieDomain: domain,
    },
    fallbackLng: APP_CONFIG.FALLBACK_LOCALE,
    interpolation: {
      escapeValue: false,
    },
  })
  .then(data => data)
  .catch(error => {
    console.error(error);
  });

export default i18n;
